__turbopack_context__.v({
  "categoryTabs": "AppTabs-module-scss-module__eMPqRq__categoryTabs",
});
